import { axiosInstanceV3 } from '../configs/axios-config';

export const validateRedirect = async (url: string) => {
  const { data } = await axiosInstanceV3.get('/funds/redirect/', {
    params: { url },
  });

  return data;
};
